<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clip-path="url(#clip0_1385_19238)">
<path d="M15.1783 7.58167C15.5008 7.91 15.4958 8.4375 15.1667 8.76L11.4783 12.3808C10.8258 13.0208 9.98583 13.34 9.145 13.34C8.31333 13.34 7.48167 13.0267 6.83167 12.3992L5.24917 10.8433C4.92083 10.5208 4.91667 9.99333 5.23917 9.665C5.56083 9.33583 6.09 9.33167 6.4175 9.655L7.995 11.2058C8.64167 11.8308 9.6625 11.8275 10.3125 11.1908L14 7.57083C14.3275 7.2475 14.8533 7.25333 15.1783 7.58167ZM20 10C20 15.5142 15.5142 20 10 20C4.48583 20 0 15.5142 0 10C0 4.48583 4.48583 0 10 0C15.5142 0 20 4.48583 20 10ZM18.3333 10C18.3333 5.405 14.595 1.66667 10 1.66667C5.405 1.66667 1.66667 5.405 1.66667 10C1.66667 14.595 5.405 18.3333 10 18.3333C14.595 18.3333 18.3333 14.595 18.3333 10Z" fill="#15567C"/>
</g>
<defs>
<clipPath id="clip0_1385_19238">
<rect width="20" height="20" fill="white"/>
</clipPath>
</defs>
</svg>
